import React from 'react';
export const ArrowIcon = ({
  direction = 'left'
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    transformOrigin: 'center',
    transform: `rotate(${rotationByDirection[direction]}deg) translateX(-1px)`
  },
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4 20l1.6-1.6-6.4-6.4L17 5.6 15.4 4l-8 8 8 8z"
}));
const rotationByDirection = {
  left: 0,
  top: 90,
  right: 180,
  bottom: 270
};